<template>
  <div>
    <div style="display: flex; align-items: center">
      <el-select
        v-model="classIndex"
        placeholder="请选择班级"
        @change="onChangeClass"
      >
        <el-option
          v-for="(item, index) in classList"
          :key="item.Id"
          :label="item.GradeNameAndClassName"
          :value="index"
        >
        </el-option>
      </el-select>
      <el-select
        class="m-left"
        v-model="ThemeValue"
        filterable
        placeholder="请输入评测主题"
      >
        <el-option
          v-for="item in ThemeList"
          :key="item.Id"
          :label="item.Name"
          :value="item.Id"
        >
        </el-option>
      </el-select>
      <el-select
        v-model="Status1"
        placeholder="请选择老师评"
        class="dropdown"
        style="margin: 10px"
        @change="onChangeTeacher"
      >
        <el-option label="已评" value="1"></el-option>
        <el-option label="未评" value="0"></el-option>
      </el-select>
      <el-select
        :disabled="disableStatus"
        v-model="Status2"
        placeholder="请选择家长评"
        class="dropdown"
        style="margin: 10px"
        @change="onChangeCustomer"
      >
        <el-option label="已评" value="2"></el-option>
        <el-option label="未评" value="3"></el-option>
      </el-select>
      <el-select
        :disabled="disableStatus"
        v-model="Status3"
        placeholder="请选择幼儿评"
        class="dropdown"
        style="margin: 10px"
        @change="onChangeChildren"
      >
        <el-option label="已评" value="4"></el-option>
        <el-option label="未评" value="5"></el-option>
      </el-select>
      <el-input
        placeholder="请输入幼儿姓名"
        v-model="searchName"
        class="input-with-select m-left"
      >
      </el-input>
      <el-button type="goon" class="m-left" @click="onClickSearch"
        >查询</el-button
      >

      <el-button
        type="goon"
        class="m-left"
        :disabled="tableData.length == 0"
        @click="onClickOpen"
        >导出</el-button
      >
      <el-button type="goon" class="m-left" @click="onEmpty">清空</el-button>
    </div>
    <!-- 评价表格 -->
    <el-row style="margin-top: 40px">
      <el-col>
        <!-- <el-card> -->
        <div class="flex-items" v-if="testInfo && testInfo.length != 0">
          <div class="flex-items" style="margin-right: 0.25rem">
            <i
              class="el-icon-success"
              style="font-size: 0.35rem; color: #67cd50"
            ></i>
            <div style="font-size: 0.2rem; margin-left: 0.0625rem">
              教师已评：{{ testInfo[0].value }}人
            </div>
          </div>
          <div class="flex-items">
            <i
              class="el-icon-warning"
              style="font-size: 0.35rem; color: #fb6e22"
            ></i>
            <div style="font-size: 0.2rem; margin-left: 0.0625rem">
              教师未评：{{ testInfo[1].value }}人
            </div>
          </div>
        </div>
        <div
          class="flex-items"
          v-if="testInfo && testInfo.length != 0"
          style="margin-top: 20px"
        >
          <div class="flex-items" style="margin-right: 0.25rem">
            <i
              class="el-icon-success"
              style="font-size: 0.35rem; color: #67cd50"
            ></i>
            <div style="font-size: 0.2rem; margin-left: 0.0625rem">
              家长已评：{{ testInfo[2].value }}人
            </div>
          </div>
          <div class="flex-items">
            <i
              class="el-icon-warning"
              style="font-size: 0.35rem; color: #fb6e22"
            ></i>
            <div style="font-size: 0.2rem; margin-left: 0.0625rem">
              家长未评：{{ testInfo[3].value }}人
            </div>
          </div>
        </div>
        <div
          class="flex-items"
          v-if="testInfo && testInfo.length != 0"
          style="margin-top: 20px"
        >
          <div class="flex-items" style="margin-right: 0.25rem">
            <i
              class="el-icon-success"
              style="font-size: 0.35rem; color: #67cd50"
            ></i>
            <div style="font-size: 0.2rem; margin-left: 0.0625rem">
              幼儿已评：{{ testInfo[4].value }}人
            </div>
          </div>
          <div class="flex-items">
            <i
              class="el-icon-warning"
              style="font-size: 0.35rem; color: #fb6e22"
            ></i>
            <div style="font-size: 0.2rem; margin-left: 0.0625rem">
              幼儿未评：{{ testInfo[5].value }}人
            </div>
          </div>
        </div>
        <el-table
          :data="tableData"
          style="width: 100%; margin-top: 0.25rem"
          border
          :header-cell-style="{ background: '#F2F5FF', color: '#333' }"
        >
          <el-table-column prop="StudyYearName" label="学届" align="center">
          </el-table-column>
          <el-table-column prop="ChildrenName" label="姓名" align="center">
          </el-table-column>
          <el-table-column prop="ClassName" label="班级" align="center">
          </el-table-column>
          <el-table-column prop="Title" label="领域" align="center">
          </el-table-column>
          <el-table-column label="老师评" align="center">
            <template slot-scope="scope">
              {{ scope.row.Status >= 1 ? "已评" : "未评" }}
            </template>
          </el-table-column>
          <el-table-column label="家长评" align="center">
            <template slot-scope="scope">
              {{ scope.row.Status >= 2 ? "已评" : "未评" }}
            </template>
          </el-table-column>
          <el-table-column label="幼儿评" align="center">
            <template slot-scope="scope">
              {{ scope.row.Status >= 3 ? "已评" : "未评" }}
            </template>
          </el-table-column>
        </el-table>
        <!-- </el-card> -->
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {
  FrontGetQuestionCategoryNodes,
  GetTeacherClassRoleInfo,
  GetOpenCycleInfoSelectResult,
  GetEval_ThemeIsTestByPage,
  GetEval_ThemeStudentByPage,
  GetThemeSelect,
} from "@/api/api.js";
import uploadUrl from "../../../api/api";

export default {
  data() {
    return {
      classList: [],
      classIndex: 0,
      cycleInfoData: [],
      cycleIndex: 0,
      domainList: [],
      domainIndex: 0,
      statusList: [
        {
          Name: "已评",
          Id: 1,
        },
        {
          Name: "未评",
          Id: 0,
        },
      ],
      statusValue: "",
      searchName: "",
      tableData: [],
      testInfo: [],
      ThemeValue: null,
      ThemeList: [],
      Status1: "",
      Status2: "",
      Status3: "",
      disableStatus: false,
    };
  },
  async created() {
    this.userInfo = JSON.parse(window.localStorage.getItem("user"));
    await this.GetThemeSelect();
    await this.GetTeacherClassRoleInfo();
    // await this.GetOpenCycleInfoSelectResult();
    // await this.FrontGetQuestionCategoryNodes();
    await this.GetEval_ThemeIsTestByPage();
    await this.GetEval_ThemeStudentByPage();
  },
  methods: {
    async onClickOpen() {
      var result = [...this.Status1, ...this.Status2, ...this.Status3];
      var sum = -1;
      for (var i = 0; i < result.length; i++) {
        if (result[i] > sum) {
          sum = result[i];
        }
      }
      window.open(
        `${
          uploadUrl.uploadUrl
        }/api/mgd/Eval_Theme/Export_AdminGetEval_ThemeStudentByPage?ThemeId=${
          this.ThemeValue
        }&ClassId=${this.classList[this.classIndex].Id}&ChildrenName=${
          this.searchName
        }&Status=${sum}&StudyYearId=${
          this.classList[this.classIndex].StudyYearId
        }&UserId=${this.userInfo.uID}`,
        "_brank"
      );
    },
    onChangeClass() {
      //console.log(123);
      this.GetOpenCycleInfoSelectResult();
    },
    onChangeTeacher(val) {
      this.Status2 = "";
      this.Status3 = "";
    },
    onChangeCustomer() {
      this.Status1 = "";
      this.Status3 = "";
    },
    onChangeChildren() {
      this.Status2 = "";
      this.Status1 = "";
    },
    async GetThemeSelect(show) {
      let res = await GetThemeSelect({ Id: 0 });
      if (res.data.success) {
        this.ThemeList = res.data.response;
        this.ThemeValue = this.ThemeList[0].Id;
      } else {
        this.ThemeList = [];
      }
    },
    onEmpty() {
      this.Status2 = "";
      this.Status1 = "";
      this.Status3 = "";
      this.searchName = "";
      this.GetEval_ThemeIsTestByPage();
      this.GetEval_ThemeStudentByPage();
    },
    //   学期评价表格
    async GetEval_ThemeStudentByPage() {
      var result = [...this.Status1, ...this.Status2, ...this.Status3];
      var sum = -1;
      for (var i = 0; i < result.length; i++) {
        if (result[i] > sum) {
          sum = result[i];
        }
      }
      //console.log(sum, "a");
      const params = {
        ThemeId: this.ThemeValue,
        StudyYearId: this.classList[this.classIndex].StudyYearId,
        ClassId: this.classList[this.classIndex].ClassId,
        PageIndex: 1,
        PageSize: 500,
        ChildrenName: this.searchName,
        Status: sum, //教师评后=1 家长评后=2 幼儿评后=3 三种状态 0是什么也没评
      };
      let res = await GetEval_ThemeStudentByPage(params);
      if (res.data.success) {
        this.tableData = res.data.response.data;
      } else {
        this.tableData = [];
      }
    },
    // 学期评价数量
    async GetEval_ThemeIsTestByPage() {
      var result = [...this.Status1, ...this.Status2, ...this.Status3];
      var sum = -1;
      for (var i = 0; i < result.length; i++) {
        if (result[i] > sum) {
          sum = result[i];
        }
      }
      //console.log(sum, "a");
      const params = {
        ThemeId: this.ThemeValue,
        StudyYearId: this.classList[this.classIndex].StudyYearId,
        ClassId: this.classList[this.classIndex].ClassId,
        PageIndex: 1,
        PageSize: 500,
        ChildrenName: this.searchName,
        Status: sum, //教师评后=1 家长评后=2 幼儿评后=3 三种状态 0是什么也没评
      };
      let res = await GetEval_ThemeIsTestByPage(params);
      if (res.data.success) {
        this.testInfo = res.data.response;
      }
    },
    // 查询
    onClickSearch() {
      this.GetEval_ThemeIsTestByPage();
      this.GetEval_ThemeStudentByPage();
    },
    //   选择领域
    async FrontGetQuestionCategoryNodes() {
      let res = await FrontGetQuestionCategoryNodes({
        IsBaby: this.cycleInfoData[this.cycleIndex].IsBaby,
        BabyLevel: this.cycleInfoData[this.cycleIndex].BabyLevel,
      });
      if (res.data.success) {
        this.domainList = res.data.response;
      }
    },
    async GetOpenCycleInfoSelectResult() {
      let res = await GetOpenCycleInfoSelectResult({
        SchoolId: this.userInfo.SchoolId,
        StudyYearsId: this.classList[this.classIndex].StudyYearId,
      });
      if (res.data.success) {
        this.cycleInfoData = res.data.response;
      }
    },
    // 获取幼儿下拉数据
    async GetTeacherClassRoleInfo() {
      let xhr = await GetTeacherClassRoleInfo();
      let themeArr = [];
      let classArr = [];
      if (this.userInfo.UserIdentity == "1") {
        classArr.push({
          GradeNameAndClassName: "全园",
          ClassName: "全园",
          GradeName: "全园",
          Id: 0,
        });
      }
      xhr.data.response.forEach((Gradeitem) => {
        Gradeitem.ClassInfo.forEach((classItem) => {
          classArr.push({
            GradeNameAndClassName:
              Gradeitem.GradeName + (classItem.Name ? classItem.Name : ""),
            ClassName: classItem.Name ? classItem.Name : "",
            Id: classItem.Id,
            ...Gradeitem,
          });
        });
      });
      this.classList = classArr;
      //console.log(this.classList);
    },
    onClick(e) {},
  },
};
</script>
<style lang="less" scoped>
.m-left {
  margin-left: 20px;
}
.input-with-select {
  width: 300px;
}
.el-button--goon {
  color: #fff;
  background-color: #5474e6;
  border-color: #5474e6;
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
}
</style>